import { Spinner, Icon } from "@chakra-ui/react";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";

// Types
import { IIndexable } from "types/common";

export enum TXN_STATUSES {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

type Keys = keyof typeof TXN_STATUSES;
export type TXN_STATUS = typeof TXN_STATUSES[Keys];

export const TXN_ICONS: IIndexable = {
  PENDING: <Spinner size="sm" color="brand.primary" />,
  SUCCESS: <Icon as={AiOutlineCheckCircle} color="#19C75E" fontSize="1.5rem" />,
  ERROR: <Icon as={AiOutlineCloseCircle} color="#FF002E" fontSize="1.5rem" />,
};

export enum TXN_TYPES {
  APPROVE = "Approve",
  STAKE = "Stake",
  UNSTAKE = "Unstake",
  CLAIM = "Claim",
  DEPOSIT = "Deposit",
  WITHDRAW = "Withdraw",
}
